import React, { useMemo, memo } from 'react';
import moment from 'moment';
import { Box, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { BaseButton } from '@alycecom/ui';
import classNames from 'classnames';

import { SLOT_TIME_FORMAT_SMALL } from '../../../../../constants/dates.constants';
import { IAlyceCustomTheme } from '../../../../../styles/alyceTheme';

const useStyles = makeStyles(() => ({
  button: {
    borderRadius: 50,
  },
  buttonText: {
    height: 20,
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: 1.5,
    color: 'inherit',
  },
}));

export interface ISlotProps {
  startAt: string;
  endAt: string;
  timezoneName: string;
  onSelect: (isSelected: boolean) => void;
  isSelected?: boolean;
  format?: string;
  fullDate: string;
}
const Slot = ({
  startAt,
  endAt,
  timezoneName,
  onSelect,
  isSelected = false,
  format = SLOT_TIME_FORMAT_SMALL,
  fullDate,
}: ISlotProps) => {
  const classes = useStyles();
  const { palette: colors } = useTheme<IAlyceCustomTheme>();

  const startDate = moment.utc(startAt).tz(timezoneName);
  const endDate = moment.utc(endAt).tz(timezoneName);

  const start = startDate.format(format);
  const end = endDate.format(format);

  const startTimeAsNumber = startDate.format('HH:mm');
  const endTimeAsNumber = endDate.format('HH:mm');

  const buttonProps = useMemo(
    () =>
      isSelected
        ? {
            color: colors.common.white,
            hoverColor: colors.common.white,
            bgColor: colors.primary.main,
            hoverBgColor: colors.primary.main,
            border: 'none',
          }
        : {
            color: colors.customStyling.highlightColor,
            bgColor: colors.common.white,
            borderSize: 2,
            borderColor: colors.grey.regular,
          },
    [isSelected, colors],
  );

  return (
    <Box width={1} mb={2}>
      <BaseButton
        data-date={fullDate}
        data-start={start}
        data-end={end}
        data-testid={`Slot.${startTimeAsNumber}-${endTimeAsNumber}`}
        width="100%"
        onClick={() => onSelect(isSelected)}
        {...buttonProps}
        overrideClass={classNames('DaySlot', classes.button)}
      >
        <span className={classes.buttonText}>
          {start} - {end}
        </span>
      </BaseButton>
    </Box>
  );
};

export default memo(Slot);
